import type { PathRouteProps } from "react-router-dom";
import Login from "@/pages/login";
import Profile from "@/pages/profile";
import Dashboard from "@/pages/dashboard";
import Users from "@/pages/users";
import UserDetail from "@/pages/users/detail";
import Notifications from "@/pages/notifications";
import Admins from "@/pages/admins";
import Content from "@/pages/content";
import DictationCourses from "@/pages/content/dictation-courses";
import DictationCourseDetail from "@/pages/content/dictation-courses/detail";
import DictationCategories from "@/pages/content/dictation-categories";
import WordCourses from "@/pages/content/word-courses";
import WordCourseDetail from "@/pages/content/word-courses/detail";
import Sentences from "@/pages/content/sentences";
import Words from "@/pages/content/words";
import ServiceSetting from "@/pages/serviceSetting";
import UpdatePassword from "@/pages/updatePassword";

export const routes: Array<PathRouteProps> = [
  {
    path: "/login",
    element: <Login />,
  },
];

export const privateRoutes: Array<PathRouteProps> = [
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/users",
    element: <Users />,
  },
  {
    path: "/content",
    element: <Content />,
  },
  {
    path: "/content/dictation-courses",
    element: <DictationCourses />,
  },
  {
    path: "/content/dictation-courses/:id",
    element: <DictationCourseDetail />,
  },
  {
    path: "/content/dictation-categories",
    element: <DictationCategories />,
  },
  {
    path: "/content/word-courses",
    element: <WordCourses />,
  },
  {
    path: "/content/word-courses/:id",
    element: <WordCourseDetail />,
  },
  {
    path: "/content/sentences",
    element: <Sentences />,
  },
  {
    path: "/content/words",
    element: <Words />,
  },
  {
    path: "/settings/admins",
    element: <Admins />,
  },
  {
    path: "/users/:id",
    element: <UserDetail />,
  },
  {
    path: "/notifications",
    element: <Notifications />,
  },
  {
    path: "/settings/service-setting",
    element: <ServiceSetting />,
  },
  {
    path: "/settings/update-password",
    element: <UpdatePassword />,
  },
];
